var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.864 12.9197L12.0001 13.008L12.1361 12.9197L20.2195 7.67567C20.2392 7.78221 20.2501 7.89151 20.2501 7.99999V17C20.2501 17.4641 20.0657 17.9092 19.7375 18.2374C19.4093 18.5656 18.9642 18.75 18.5001 18.75H5.50006C5.03593 18.75 4.59081 18.5656 4.26262 18.2374C3.93444 17.9092 3.75006 17.4641 3.75006 17V7.99999C3.75006 7.89151 3.76093 7.78221 3.78062 7.67567L11.864 12.9197ZM18.5001 4.74999H5.50006C4.63811 4.74999 3.81146 5.0924 3.20196 5.7019C2.59247 6.31139 2.25006 7.13804 2.25006 7.99999V17C2.25006 17.8619 2.59247 18.6886 3.20196 19.2981C3.81146 19.9076 4.63811 20.25 5.50006 20.25H18.5001C19.362 20.25 20.1887 19.9076 20.7982 19.2981C21.4077 18.6886 21.7501 17.8619 21.7501 17V7.99999C21.7501 7.13804 21.4077 6.31139 20.7982 5.7019C20.1887 5.0924 19.362 4.74999 18.5001 4.74999ZM18.5001 6.24999C18.812 6.24999 19.0937 6.32454 19.3356 6.45964L12.0001 11.2023L4.66451 6.45964C4.90638 6.32454 5.18814 6.24999 5.50006 6.24999H18.5001Z",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailme);
export default __webpack_public_path__ + "static/media/mailme.36394583f3c5aa597a2e4eed3952bc8a.svg";
export { ForwardRef as ReactComponent };